import React from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

const Button = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  height: 40px;
  border: none;
  border-radius: 8px;
  background-color: #f2f4f7;
  //border-color: #c5c9d3;
  color: #344054;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease,
    color 0.15s ease;

  &:hover {
    
  border-color: #c5c9d3;
  background-color: #e3e8ec;
    //border-color: #cfd2d5;
  }
`;

const Icon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  //background: #f9fafb;
  //border: 1px solid #e5e7eb;
  margin-right: -5px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
`;

const BackButton = ({
  to = -1,
  label = "Back",
  onClick,
  className,
  ...rest
}) => {
  const navigate = useNavigate();

  const handleClick = (event) => {
    if (onClick) {
      onClick(event);
    }

    if (event.defaultPrevented) return;

    navigate(to ?? -1);
  };

  return (
    <div style={{
      display: "flex",
      justifyContent: "space-between"
    }}>
      <div></div>
      <Button type="button" onClick={handleClick} className={className} {...rest}>
      <Icon>&lt;</Icon>
      <span>{label}</span>
    </Button>
    </div>
  );
};

export default BackButton;

